import React from "react";
import { LabelModes } from "../../../ui-components/molecules/labeled-inputs/labeledInput";
import XGSFormInput from "../../../ui-components/form/input/xgsFormInput";
import XGSFormSelect from "../../../ui-components/form/select/xgsFormSelect";
import { divisionOptions, terminalTypeOptions, timezoneOptions, WMSWarehousingOptions } from "app/data/terminal-details/models";
import { useFormikContext } from "formik";
import { AddTerminal } from "app/data/terminal-details/models";

const BasicInfo = (): React.ReactElement => {

    const { values, setFieldValue } = useFormikContext<AddTerminal>();
    return (
        <>
            <div className="edit-flex-box">
                <div className="edit-flex-box__item">
                    <XGSFormInput
                        type="text"
                        name="terminalName"
                        required={true}
                        labelMode={LabelModes.column}
                        label="Terminal Name"
                        className="width-50"
                    />
                    <XGSFormInput
                        type="text"
                        name="terminalNumber"
                        required
                        labelMode={LabelModes.column}
                        label="Terminal Number"
                        className="width-50"
                        disabled
                        infotext="This is system generated"
                    />
                </div>

                <div className="edit-flex-box__item">
                    <XGSFormInput
                        type="text"
                        name="airportCode"
                        required
                        labelMode={LabelModes.column}
                        label="Airport Code"
                        className="width-50"
                    />
                    <XGSFormSelect
                        label="Division"
                        name="division"
                        required={true}
                        options={divisionOptions}
                        value={values.division ? divisionOptions.find(
                            (option) => option.label === values.division
                        ) : null}
                        onValueChange={(option) => {
                            setFieldValue("division", option?.label ?? "");
                        }}
                        className="width-50"
                        labelMode={LabelModes.column}
                    />
                </div>

                <div className="edit-flex-box__item">

                    <XGSFormSelect
                        label="Timezone"
                        name="timezone"
                        required={true}
                        options={timezoneOptions}
                        value={values.timezone ? timezoneOptions.find(
                            (option) => option.value === values.timezone
                        ) : null}
                        onValueChange={(option) => {
                            setFieldValue("timezone", option?.value ?? "");
                        }}
                        formik
                        className="width-50"
                        labelMode={LabelModes.column}
                    />
                    <XGSFormSelect
                        label="Terminal Type"
                        name="terminalType"
                        required={true}
                        options={terminalTypeOptions}
                        value={values.terminalType ? terminalTypeOptions.find(
                            (option) => option.value === values.terminalType
                        ) : null}
                        onValueChange={(option) => {
                            setFieldValue("terminalType", option?.value ?? "");
                        }}
                        formik
                        className="width-50"
                        labelMode={LabelModes.column}
                    />
                </div>
                <div className="edit-flex-box__item">

                    <XGSFormSelect
                        label="WMS Warehousing"
                        name="wmsWarehousing"
                        required={true}
                        options={WMSWarehousingOptions}
                        value={values.wmsWarehousing ? WMSWarehousingOptions.find(
                            (option) => option.value === values.wmsWarehousing
                        ) : null}
                        onValueChange={(option) => {
                            setFieldValue("wmsWarehousing", option?.value ?? "");
                        }}
                        formik
                        className="width-50"
                        labelMode={LabelModes.column}
                    />
                </div>

            </div>

        </>


    )
}
export default BasicInfo;
